/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function OffCyclePlanners(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    EchoService: JS5Object,
    NavbarUtilService: JS5Object,
    NotificationService:JS5Object,
    PaginationService: JS5Object,
    PartnerEditService: JS5Object,
    PartnerResourceFactory: JS5Object,
    PermissionsService:JS5Object,
    SearchFilterService: JS5Object
) {
    const permissionViewState = 'DASHBOARD_OFF_CYCLE_PLANNERS_VIEW_STATE';


	//======//
	// Grid //
	//======//

	this.offCyclePlannerGridColumns = [
		{
			name: 'checkMarkRowHeaderCol',
			field: 'checkMark',
			width: 30,
			enableColumnMenu: false,
			enableSorting: false,
			enableColumnResizing: false,
			cellTemplate: 'components/visual/grid/check-mark-template.html',
			headerCellTemplate: '<div class="ui-grid-cell-contents" col-index="renderIndex" ng-click="grid.appScope.$ctrl.toggleRows($event)">' +
			'<input type="checkbox" ng-checked="grid.selection.selectAll"/><label></label></div>'
		},
		{
			field: 'name',
			name: 'Name',
			sortable: true,
			enableColumnMenu: false
		},
		{
			field: 'lookBack',
			name: 'Back',
			sortable: false,
			enableColumnMenu: false,
            width: 90
		},
		{
			field: 'lookForward',
			name: 'Forward',
			sortable: false,
			enableColumnMenu: false,
            width: 90
		},
		{
			field: 'scheduleLabel',
			name: 'Schedule / Interval',
			sortable: false,
			enableColumnMenu: false
		},
		{
			field: 'lastRun',
			name: 'Last Run',
			cellFilter: 'amDateFormat:"MMM D, YYYY, h:mm A"',
			sortable: false,
			enableColumnMenu: false
		},
		{
			field: 'nextRun',
			name: 'Next Run',
			cellFilter: 'amDateFormat:"MMM D, YYYY, h:mm A"',
			sortable: false,
			enableColumnMenu: false
		}
	];

	this.toggleRows = (event: JS5Object) => {
		if (this.gridApi.selection.selectAll) {
			this.gridApi.selection.clearSelectedRows(event);
			this.gridApi.selection.selectAll = false;
		} else {
			this.gridApi.selection.selectAllVisibleRows(event);
			this.gridApi.selection.selectAll = true;
		}

        this.startPlannersTimeout = null;
        this.selectedPlanners = this.gridApi.selection.getSelectedRows();
	};

	this.gridRowSelectionChangedHandler = (row: JS5Object, event: JS5Object): void => {
		if (event) {
            this.startPlannersTimeout = null;
			if (row.isSelected) {
				this.selectedPlanners.push(row.entity);
			} else {
				_.remove(this.selectedPlanners, (planner: JS5Object) => {
					return planner.id === row.entity.id;
				});
			}
		}
	};

	this.offCyclePlannersGrid = {
		selectionRowHeaderColName: 'checkMarkRowHeaderCol',
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableSelectAll: true,
		enableColumnResizing: true,
		enablePaginationControls: false,
		enableFullRowSelection: true,
		enableSorting: true,
		rowHeight: 26,
		multiSelect: true,
		minRowsToShow: 25,
		enableVerticalScrollbar: 2,
		columnDefs: this.offCyclePlannerGridColumns,
		rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
		onRegisterApi: (gridApi: JS5Object) => {
			this.gridApi = gridApi;
			this.gridApi.grid.registerRowsProcessor(this.processGridFilter, 200);
			this.gridApi.selection.on.rowSelectionChanged(null, this.gridRowSelectionChangedHandler);
		}
	};


	//======//
	// REST //
	//======//

	let getData = (): void => {
		this.loadingIndicator.show = true;
		let offset = this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1);

		PartnerEditService.getPartnerPlanners({
			fetchOffset: offset,
			fetchLimit: this.pagingOptions.pageSize
		}).then((response: JS5Object) => {
			this.offCyclePlannersGrid.data = _.cloneDeep(_.sortBy(response.planners, ['name']));
			PaginationService.parseResponseHeaders(response.headers);
			this.searchText = $location.search().searchText || null;
			this.loadingIndicator.show = false;
		});
	};

	this.deliverOffCyclePlanners = () => {
        if (!this.startPlannersTimeout) {
            let message = 'Planner(s) may take longer than expected. You will be notified once sent.';
            let newTimeout: JS5Promise;
            newTimeout = $timeout(() => {
                if (this.startPlannersTimeout === newTimeout) {
                    this.startPlannersTimeout = null;
                }
            }, 5000);
            this.startPlannersTimeout = newTimeout;
            NotificationService.createInfoNotification(message);
            PartnerEditService.deliverOffCyclePlanners(
                this.selectedPlanners,
                this.offCyclePlannersMessage
            ).then((response: JS5Object) => {
                // API will create an event when planner workflow is started
                EchoService.awaitNotification(response.id, (event: any) => {
                    let status: any;
                    switch (event.eventPayload.status) {
                        case 'SUCCESS':
                            status = EchoService.EventStatus.SUCCEEDED;
                            break;
                        case 'FAILURE':
                            status = EchoService.EventStatus.FAILED;
                            break;
                        default:
                            status = EchoService.EventStatus.PENDING;
                    }
                    return {
                        message: event.eventPayload.body,
                        status,
                    };
                });
            });
        } else {
            let message = 'Please wait a bit before redelivering planner(s)...';
            NotificationService.createWarningNotification(message);
        }

	};


    //===================//
    // Template Response //
    //===================//

	this.processGridFilter = (renderableRows: JS5Object[]) => {
		renderableRows.forEach((row) => {
			row.visible = (this.searchText === null) ?
				true :
				row.entity.name.toLowerCase().indexOf(this.searchText) !== -1;
		});
		return renderableRows;
	};

    NavbarUtilService.viewSearchFunction = (searchText: string, forceRefresh: boolean) => {
        this.searchText = searchText;
        getData();
    };

    this.messageChangedHandler = () => {
        this.startPlannersTimeout = null;
    };


	//============//
	// Pagination //
	//============//

	this.onPaginationChanged = () => {
		this.gridApi.selection.clearSelectedRows();
		getData();
	};

	this.paginationPrevPageHandler = () => {
		--this.pagingOptions.currentPage;
		this.onPaginationChanged();
	};

	this.paginationNextPageHandler = () => {
		++this.pagingOptions.currentPage;
		this.onPaginationChanged();
	};

	this.paginationJumpToPageHandler = () => {
		this.onPaginationChanged();
	};


	//===========//
	// Lifecycle //
	//===========//

	this.$onInit = (): void => {
	    this.startPlannersTimeout = null;
		this.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		this.pagingOptions = PaginationService;
		PaginationService.pageDataResource = PartnerResourceFactory;

		this.paginationDefs = {
			paginationPrevPageHandler: this.paginationPrevPageHandler,
			paginationNextPageHandler: this.paginationNextPageHandler,
			paginationPageSizeChanged: this.onPaginationChanged,
			paginationJumpToPageHandler: this.paginationJumpToPageHandler,
			pagingOptions: this.pagingOptions
		};

		BreadcrumbService.clearBreadcrumbs();
		this.breadcrumbLabel = 'Planners / Avails / Feeds';
		this.selectedPlanners = [];

        SearchFilterService.populateCriteriaFromLocationSearch();
        PermissionsService.getReadWritePermissions(permissionViewState).then((permissions:JS5Object) =>{
            this.permissions = permissions;
            getData();
        });
	};

}

angular.module('prism-ui.offCyclePlanners').component('offCyclePlannersView', {
	templateUrl: 'dashboard/offCyclePlanners/off-cycle-planners-template.html',
	controller: OffCyclePlanners,
	bindings: {}
});
